var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNotYetEligible(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "24px",
    height: "25px",
    viewBox: "0 0 24 25",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "not_yet_eligible") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Desktop",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Results---1-potentially-eligible-(A)",
    transform: "translate(-734.000000, -496.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-2",
    transform: "translate(240.000000, 483.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-4",
    transform: "translate(272.000000, 8.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-8",
    transform: "translate(222.000000, 5.352941)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "not_yet_eligible",
    transform: "translate(0.000000, 0.470588)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    stroke: "#C39E02",
    strokeWidth: 2,
    cx: 12,
    cy: 12,
    r: 11
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6,10.1764706 C7.1045695,10.1764706 8,11.0719011 8,12.1764706 C8,13.2810401 7.1045695,14.1764706 6,14.1764706 C4.8954305,14.1764706 4,13.2810401 4,12.1764706 C4,11.0719011 4.8954305,10.1764706 6,10.1764706 Z M12,10.1764706 C13.1045695,10.1764706 14,11.0719011 14,12.1764706 C14,13.2810401 13.1045695,14.1764706 12,14.1764706 C10.8954305,14.1764706 10,13.2810401 10,12.1764706 C10,11.0719011 10.8954305,10.1764706 12,10.1764706 Z M18,10.1764706 C19.1045695,10.1764706 20,11.0719011 20,12.1764706 C20,13.2810401 19.1045695,14.1764706 18,14.1764706 C16.8954305,14.1764706 16,13.2810401 16,12.1764706 C16,11.0719011 16.8954305,10.1764706 18,10.1764706 Z",
    id: "Combined-Shape",
    fill: "#C6A000"
  })))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNotYetEligible);
export default __webpack_public_path__ + "static/media/not_yet_eligible.80d2bea5fc8e953762b4c36ec887afeb.svg";
export { ForwardRef as ReactComponent };